import { Box, styled } from '@mui/material';
import React from 'react';

const TypingIndicator = styled('div')({
  display: 'flex',
  gap: '4px',
});

const Dot = styled('span')<{
  size?: string;
}>(({ size = '8px' }) => ({
  'display': 'inline-block',
  'width': size,
  'height': size,
  'backgroundColor': '#555',
  'borderRadius': '50%',
  'opacity': 0,
  'animation': 'blink 1s infinite',

  '&:nth-of-type(1)': {
    animationDelay: '0s',
  },
  '&:nth-of-type(2)': {
    animationDelay: '0.2s',
  },
  '&:nth-of-type(3)': {
    animationDelay: '0.4s',
  },

  '@keyframes blink': {
    '0%, 100%': {
      opacity: 0,
    },
    '50%': {
      opacity: 1,
    },
  },
}));
type TypingIndicatorProps = {
  size?: string;
  children?: React.ReactNode;
};
const TypingIndicatorComponent: React.FC<TypingIndicatorProps> = ({
  children,
  size = '8px',
}) => {
  return (
    <Box
      display='flex'
      alignItems='baseline'
    >
      {children}
      <TypingIndicator>
        <Dot size={size} />
        <Dot size={size} />
        <Dot size={size} />
      </TypingIndicator>
    </Box>
  );
};

export default TypingIndicatorComponent;
